export const EmployeeQualificationFactory = () => {
    return function EmployeeQualification() {

        this.id = null;
        this.name = null;
    };
};
